<template>
  <div class="w-100">
    <!-- <form ref="form" v-kendo-validator="!readOnly" novalidate> -->
      <div class="page-header d-flex w-100">
        <div class="title-col d-flex w-50">
          <span class="title-icon">
            <span class="nt-people-fill"></span>
          </span>
          <span class="title-text">New Tenant</span>
        </div>
        <!-- <div class="text-right ml-auto" v-if="!readOnly">
          <button class="k-button k-primary ml-2" type="button" @click="save">Save</button>
        </div>-->
        <!-- <div class="text-right ml-auto">
          <buttongroup>
            <k-button :togglable="true">
                Basic Tenant
            </k-button>
            <k-button :togglable="true">
                Advanced Tenant
            </k-button>
          </buttongroup >
        </div>-->

        <div class="text-right ml-auto">
          <div class="btn-group">
            <button type="button" class="btn btn-default" @click="onClickTabTenants(false)">Basic Tenant</button>
            <button type="button" class="btn btn-default" @click="onClickTabTenants(true)">Advanced Tenant</button>
          </div>
        </div>
      </div>
      <div class="page-body">
        <kendo-tabstrip class>
          <ul>
            <li class="k-state-active">Tenant Details</li>
            <li>Products, Packages & Add Ons</li>
            <li>User & Role</li>
            <li v-show="isAdvanced">Assign Database</li>
          </ul>
          <div class="overflow-hidden">
            <tenant-detail-form></tenant-detail-form>
          </div>
          <div class>
            <product-selection></product-selection>
          </div>
          <div class>
            <add-users></add-users>
          </div>
          <div class>
            <database-config></database-config>
          </div>
        </kendo-tabstrip>
        <!-- <div class> -->
        <!-- <div class="row"> -->
        <!-- <div class="col-sm-4"> -->
        <!-- <div class="form-group">
                <label class="required-field">Name</label>
                <k-input
                  :name="'Tenant Name'"
                  class="w-100"
                  :required="true"
                  v-model="tenant.name"
                  :disabled="readOnly"
                />
        </div>-->
        <!-- </div> -->

        <!-- <div class="col-sm-4"> -->
        <!-- <div class="form-group">
                <label class="required-field">Tenant Contact</label>
                <k-input
                  :name="'Tenant Contact Person'"
                  class="w-100"
                  :required="true"
                  v-model="tenant.contactPerson"
                  :disabled="readOnly"
                />
        </div>-->
        <!-- </div> -->
        <!-- <div class="col-sm-4"> -->
        <!-- <div class="form-group">
                <label class="required-field">Tenant Contact No</label>
                <k-input
                  :name="'Tenant Contact No'"
                  class="w-100"
                  :required="true"
                  v-model="tenant.contactNo"
                  :disabled="readOnly"
                />
        </div>-->
        <!-- </div> -->
        <!-- <div class="col-sm-4"> -->
        <!-- <div class="form-group">
                <label class="required-field">Tenant Contact Email</label>
                <k-input
                  :name="'Contact Email'"
                  class="w-100"
                  type="email"
                  :required="true"
                  v-model="tenant.emailId"
                  :disabled="readOnly"
                />
        </div>-->
        <!-- </div> -->
        <!-- <div class="col-sm-4"> -->
        <!-- <div class="form-group">
                <label class="required-field">Sub Domain Name</label>
                <k-input
                  :name="'Sub Domain Name '"
                  class="w-100"
                  :required="true"
                  v-model="tenant.subDomainName"
                  :disabled="readOnly"
                />
        </div>-->
        <!-- </div> -->
        <!-- <div class="col-sm-4"> -->
        <!-- <div class="form-group">
                <label>Website</label>
                <k-input
                  :name="'Website'"
                  class="w-100"
                  :required="true"
                  v-model="tenant.website"
                  :disabled="readOnly"
                />
        </div>-->
        <!-- </div> -->
        <!-- <div class="col-sm-4"> -->
        <!-- <div class="form-group d-flex">
                <label>Use Shared DB</label>
                <b-form-checkbox
                  v-model="tenant.useSharedDb"
                  class="ml-2"
                  :disabled="readOnly"
                  @change="resetDB"
                ></b-form-checkbox>
        </div>-->
        <!-- </div> -->
        <!-- </div> -->
        <!-- </div> -->
        <!-- <div class="buttons">
          <button type="button" class="btn btn-primary">Save</button>
          <button type="button" class="btn btn-info">Save & Activate</button>
          <button type="button" class="btn btn-default">Cancel</button>
        </div> -->
      </div>
    <!-- </form> -->
  </div>
</template>

<script>
// import { mapFields } from "vuex-map-fields";
// import { createNamespacedHelpers } from "vuex";
// import { notifyApiError, notify } from "../../utils/notification-helper";
import TenantDetailForm from "./TenantDetailForm";
import ProductSelection from "./ProductSelection";
// import AddOnSelection from "./AddOnSelection";
import AddUsers from "./AddUsers";
import DatabaseConfig from "./DatabaseConfig";
// const { mapState, mapActions } = createNamespacedHelpers("onboarding");
export default {
  data: function() {
    return {
      isAdvanced:false
    };
  },
  components: {
    TenantDetailForm,
    ProductSelection,
    AddUsers,
    // AddOnSelection,
    DatabaseConfig
  },
  methods: {
    // ...mapActions(["addTenant", "resetDB"]),
    // save: function() {
    //   if (!this.kendoValidator.validate()) {
    //     return this.$emit("can-continue", { value: false });
    //   }
    //   this.addTenant()
    //     .then(message => {
    //       notify(message);
    //       this.canContinue();
    //     })
    //     .catch(notifyApiError);
    // },

    // canContinue() {
    //   this.$emit("can-continue", { value: true });
    // },
    onClickTabTenants(flag){
      this.isAdvanced = flag
    }
  },
  // computed: {
  //   ...mapFields(["onboarding.tenant", "onboarding.product"]),
  //   ...mapState(["products"])
  // },
  // props: ["readOnly"],
  // mounted() {}
};
</script>

<style>
.k-tabstrip-top > .k-tabstrip-items {
 border-bottom: 1px solid #ddd;
 border-top: none;
}

td,
th {
  text-align: center;
}
</style>